const i18n = {
  defaultLocale: 'de-DE',
  locales: ['de-DE', 'de-AT', 'en-US'],
  localeDetection: false, // disable automatic redirection on the user's preferred locale
};

const next18nextConfig = {
  i18n,
  reloadOnPrerender: process.env.NODE_ENV === 'development',
};

module.exports = next18nextConfig;
